import React, { Component } from 'react';
import './coins-box.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
// import Coin1 from "./coin-1.png";
// import Coin2 from "./coin-2.png";
// import Coin3 from "./coin-3.png";

import {
  PrimaryButton
} from '../../components';

export default class CoinsBox extends Component {
  componentWillMount() {
    AOS.init();
  }

  render() {
    return (
      <div className="rdp-react-template-component-coins-box">
        <span className="rdp-react-template-component-coins-box-back" onClick={() => this.props.onClose()}></span>
        <h1 className="rdp-react-template-component-coins-box-title" data-aos="fade-up" data-aos-duration="1000">{this.props.title}</h1>
        <p className="rdp-react-template-component-coins-box-message" data-aos="fade-up" data-aos-duration="2000" dangerouslySetInnerHTML={{__html: this.props.message}}></p>
        <div data-aos="fade-up" data-aos-duration="3000" style={{marginTop: "30px"}}>
          <PrimaryButton
            label={this.props.buttonLabel || "Voltar"}
            icon="talk"
            onClick={() => this.props.onClose && this.props.onClose()}
          />
        </div>
        <div className="rdp-react-template-component-coins-box-coins">
          <div className="rdp-react-template-component-coins-box-coins-line-1">
            <div className="rdp-react-template-component-coins-box-coin-1" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
              {/* <img src={Coin3}/> */}
            </div>
            <div className="rdp-react-template-component-coins-box-coin-2" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="1000">
              {/* <img src={Coin2}/> */}
            </div>
          </div>
          <div className="rdp-react-template-component-coins-box-coins-line-2">
            <div className="rdp-react-template-component-coins-box-coin-3" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="1400">
              {/* <img src={Coin1}/> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
